import React, { useEffect, useState } from "react";
import CreatePassword from "./Steps/CreatePassword";
import Confirmation from "./Steps/Confirmation";
import { useSelector } from "react-redux";

function Form(props) {
  const [stepState, setStepState] = useState(1);
  const employeeReducer = useSelector((state) => state.employeeReducer);

  useEffect(() => {
    setStepState(employeeReducer.stepEmployeePassword);
  }, [employeeReducer]);

  const FormStep = () => {
    switch (stepState) {
      case 1: {
        return <CreatePassword />;
      }
      case 2: {
        return <Confirmation />;
      }
      default: {
        return <CreatePassword />;
      }
    }
  };

  return <FormStep />;
}

export default Form;
